export default () => {
  let accordions = document.querySelectorAll('.js-accordion');

  accordions.forEach(accordion => {
    let items      = accordion.querySelectorAll('.js-accordion-item');
    let isSingle   = accordion.getAttribute('data-single') === 'true';
    let openedItem = null;

    items.forEach(item => {
      let btn     = item.querySelector('.js-accordion-btn');
      let content = item.querySelector('.js-accordion-content');

      btn.addEventListener('click', e => {
        e.currentTarget.blur();

        if (item.classList.contains('open')) {
          content.removeAttribute('style');
          item.classList.remove('open');
        } else {
          content.style.height = `${content.scrollHeight}px`;

          if (isSingle && openedItem !== item) {
            openedItem?.querySelector('.js-accordion-content').removeAttribute('style');
            openedItem?.classList.remove('open');
            openedItem = item;
          }

          item.classList.add('open');
        }
      });
    });
  });
}
